import React, { useEffect } from 'react';
import styled from 'styled-components';
import { ProductCode } from 'types';
import { Link, match } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Layout from '../../components/templates/layout';
import { useIntl } from '../../common/config/i18n';
import {
  productCodesSelectors,
  productCodeActions,
  productCodeSelectors,
  ClearStateSliceActions,
} from '../../common/config/store';
import history from '../../app-router/history';
import FormProductCode from '../../components/templates/form-product-code';
import Card from '../../components/molecules/card';

const Wrapper = styled.div`
  margin: 5px;
`;
const StyledBreadcrumbWrapper = styled.div`
  margin: 10px 0 20px 20px;
`;
interface Props {
  match: match<Params>;
}
interface Params {
  id: string;
}
const ProductCodePage: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const { t } = useIntl();
  const { id } = props.match.params;
  const productCodes = useSelector(productCodesSelectors.productCodesSelector);
  const productCode = id ? productCodes.find((productCode) => productCode?.id?.toString() === id) : undefined;
  const error = useSelector(productCodeSelectors.errorSelector);
  const status = useSelector(productCodeSelectors.statusSelector);

  useEffect(() => {
    return () => {
      dispatch(ClearStateSliceActions.clearStateSlice({ sliceReducer: 'ProductCode', sliceKey: 'error' }));
      dispatch(ClearStateSliceActions.clearStateSlice({ sliceReducer: 'ProductCode', sliceKey: 'status' }));
    };
  }, [dispatch]);

  const onSubmitHandler = (values: ProductCode) => {
    dispatch(
      productCodeActions.createProductCode(values, (result) => {
        if (!result.cancelled && !result.error) {
          history.push('/product-codes');
        }
      })
    );
  };
  const title = t('ProductCodesPage', 'PRODUCT_CODES_CREATE');

  return (
    <div>
      <Layout />
      <Wrapper>
        <StyledBreadcrumbWrapper>
          <Link to="/product-codes">{t('ProductCodesPage', 'PRODUCT_CODES_BACK')}</Link>
        </StyledBreadcrumbWrapper>

        <Card title={title}>
          <FormProductCode
            onSubmit={onSubmitHandler}
            productCode={productCode || undefined}
            error={error}
            status={status}
          />
        </Card>
      </Wrapper>
    </div>
  );
};

export default ProductCodePage;
